function InvoiceCard({ custPrename, custName, createdAt, total, onclick, paid, invoiceNumber }) {
    return (
        <div
            className="cardContainer"
            onClick={onclick}
        >
            <p className="cardText">Rechnung von: {custPrename} {custName}</p>
            <p className="cardText">Erstellt am: {createdAt || ''}</p>
            <p className="cardText">Höhe: {total}</p>
            <p className="cardText">Bezahlt: {paid}</p>
            <p className="cardText">Rechnungsnr.: {invoiceNumber}</p>
        </div>
    );
}

export default InvoiceCard;